@if (loadingRoot) {
	<rl-loader></rl-loader>
} @else if (hasRootLoadFailed) {
	<p class="text-danger" role="alert" data-cy="sigmaReportsLoadError">Unable to load Reports. Please try again later.</p>
} @else if (rootNodes.length > 0) {
	<div class="file-tree pe-2">
		@for (node of rootNodes; track trackByNodeId($index, node)) {
			<ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: node }"></ng-container>
		}
	</div>
} @else {
	<p class="text-muted" data-cy="sigmaNoReportsAvailable">There are no Reports available for this user to select.</p>
}

<ng-template #nodeTemplate let-node>
	<div class="file-node">
		<div class="file-row" [class.selected]="isWorkbook(node.file) && isSelected(node.file.id)"
			[class.disabled]="isWorkbook(node.file) && isDisabled(node.file.id)">
			<button type="button" class="expand-toggle" (click)="toggleNode(node)" [attr.aria-expanded]="node.expanded"
				[title]="node.expanded ? 'Collapse' : 'Expand'">
				<i class="fal" aria-hidden="true" [class.fa-chevron-right]="!node.expanded"
					[class.fa-chevron-down]="node.expanded"></i>
			</button>
			<i class="fal file-icon" [ngClass]="iconClass(node.file)" aria-hidden="true"></i>
			<a class="file-name cursor-pointer" [class.workbook-name]="isWorkbook(node.file)"
				(click)="toggleNode(node)">
				{{ node.file.name }}
			</a>
			@if (isWorkbook(node.file) && canSelect(SigmaObjectLevel.Workbook)) {
				<button type="button" class="btn btn-icon btn-success ms-auto" [disabled]="isDisabled(node.file.id)"
					(click)="workbookSelected(node.file)" [title]="actionLabel + ' workbook'">
					<i class="fal fa-plus" aria-hidden="true"></i>
				</button>
			}
		</div>

		@if (node.expanded) {
			<div class="file-children">
				@if (node.loading) {
					<rl-loader></rl-loader>
				}
				@if (node.hasLoadFailed) {
					<p class="text-danger empty-children" role="alert">Unable to load this workbook. Collapse and expand it to try again.</p>
				}
				@if (!node.loading && isContainer(node.file) && node.children) {
					@if (node.children.length === 0) {
						<p class="text-muted empty-children">This folder is empty</p>
					}
					@for (child of node.children; track trackByNodeId($index, child)) {
						<ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: child }"></ng-container>
					}
				}
				@if (!node.loading && isWorkbook(node.file) && node.pages) {
					@if (node.pages.length === 0) {
						<p class="text-muted empty-children">No pages in this workbook</p>
					}
					@for (pageNode of node.pages; track trackByPageId($index, pageNode)) {
						<div class="page-node">
							<div class="page-row" [class.selected]="isSelected(node.file.id, pageNode.page.id)"
								[class.disabled]="isDisabled(node.file.id, pageNode.page.id)">
								<i class="fal fa-file page-icon" aria-hidden="true"></i>
								<span class="file-name page-name cursor-pointer">{{ pageNode.page.name }}</span>
								@if (canSelect(SigmaObjectLevel.Page)) {
									<button type="button" class="btn btn-icon btn-success ms-auto"
										[disabled]="isDisabled(node.file.id, pageNode.page.id)"
										(click)="pageSelected(node.file, pageNode.page)"
										[title]="actionLabel + ' page'">
										<i class="fal fa-plus" aria-hidden="true"></i>
									</button>
								}
							</div>
							@if (pageNode.elements.length > 0) {
								<div class="element-list">
									@for (element of pageNode.elements; track trackByFileId($index, element)) {
										<div class="element-row"
											[class.selected]="isSelected(node.file.id, pageNode.page.id, element.id)"
											[class.disabled]="isDisabled(node.file.id, pageNode.page.id, element.id)">
											<i class="fal fa-chart-bar element-icon" aria-hidden="true"></i>
											<span
												class="file-name element-name cursor-pointer">{{ element.name }}</span>
											@if (canSelect(SigmaObjectLevel.Element)) {
												<button type="button" class="btn btn-icon btn-success ms-auto"
													[disabled]="isDisabled(node.file.id, pageNode.page.id, element.id)"
													(click)="elementSelected(node.file, pageNode.page, element)"
													[title]="actionLabel + ' element'">
													<i class="fal fa-plus" aria-hidden="true"></i>
												</button>
											}
										</div>
									}
								</div>
							}
						</div>
					}
				}
			</div>
		}
	</div>
</ng-template>